module.exports = __webpack_public_path__ + "static/quaals_feather_token_swan_boat-485eef1602e7212d36ed298dba9ee503.jpeg";